import { useWallet } from "@txnlab/use-wallet";
import { Loader, Check } from "lucide-react";

export function StepTitle({
    error,
    title,
    step,
    children,
  }: {
    error: string;
    title: string;
    step: number;
    children: React.ReactNode;
  }) {
    const { activeAccount, providers } = useWallet();
    const activeProvider = providers?.find(
      (provider) => provider.metadata.id === activeAccount?.providerId
    );
  
    if (error)
      return <div className="text-muted-foreground">Something went wrong</div>;
  
    switch (step) {
      case 1:
        return <div>{children}</div>;
      case 2:
        return (
          <>
            Sign in <strong>{activeProvider?.metadata.name} wallet</strong>
            <img src={activeProvider?.metadata.icon} width={24} height={24} className="ml-3 rounded-xl animate-bounce shadow-primary shadow-[0_0_12px_1px]" />
          </>
        );
      case 3:
        return <>Sending {title} transactions <Loader className="mr-2 animate-spin"/></>;
      case 4:
        return <>Waiting for confirmation <Loader className="mr-2 animate-spin"/></>;
      case 5:
        return <div className="flex font-bold text-primary">Your {title} is complete <Check className="ml-1" /></div>
    }
  }
  